import React, { useState } from 'react';
import { Search } from 'lucide-react';
import GlobalSearchModal from './GlobalSearchModal';

interface GlobalSearchIconProps {
  className?: string;
}

const GlobalSearchIcon: React.FC<GlobalSearchIconProps> = ({ className }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        className={`p-2 transition-colors duration-200 ${className || 'text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-50'}`}
        aria-label="Search"
      >
        <Search className="w-6 h-6" />
      </button>

      <GlobalSearchModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default GlobalSearchIcon;